//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext,useRef} from 'react';
import {
  Box,
  Button,
  Modal,
  TextField,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

// === UTILS ===
import { getHexAlpha } from 'components/styles.utils';

// === API ===
import {Typography} from '../../../../../../../../node_modules/@mui/material/index';
import {updateFileRuleComment} from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function CommentModal(props) {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const theme = useTheme();

  const ref = useRef();
  
  // === STYLE ===
  const _styles = {
    modal: {
      // backgroundColor: theme.palette.panel.main,
    },
    container: { 
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
      position: 'absolute',
      top: '25%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width : 400,
      // height: 200,
      boxShadow: 24,
      padding: '1rem',
      justifyContent: 'center',
      alignText: 'center',
      borderRadius: '0.5rem',
    },
    user_select: {
      width: '100%',
      marginRight: '1rem',
    },
    comment: {
      width: '100%',
      marginTop: '0.5rem',
      // backgroundColor: 'secondary',
    },
    control_box: {
      padding: '1rem',
      paddingBottom: 0,
    },
    button_ok: {
    },
    button_cancel: {
      boxShadow: 0,
    },
  };

  // === ATTRIBUTES ===
  const _attr = {
    MODAL: {
      sx      : _styles.modal,
      open    : props.is_open,
      onClose : props.onClose,
    },
    COMMENT: {
      sx        : _styles.comment,
      inputRef  : ref,
      id        : 'field-comment',
      variant   : 'filled',
      multiline : true,
      minRows   : 5,
      defaultValue : props.value,
    },
    CONTROL_BOX: {
      sx: _styles.control_box,
    },
    BUTTON_OK: {
      sx      : _styles.button_ok,
      variant : 'contained',
      color   : 'primary',
      children: 'OK',
      onClick  : onClick_OK,
    },
    BUTTON_CANCEL: {
      sx       : _styles.button_cancel,
      variant  : 'contained',
      color    : 'grey',
      children : 'CANCEL',
      onClick  : props.onClose,
    },
  }

  //#endregion

  //#region [EFFECT]



  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onClick_OK() {
    //-----------------------------------------------------------------
    props.onConfirm( ref.current.value );
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Modal {..._attr.MODAL} >
        <Box sx={_styles.container}>
          <Typography>Comment</Typography>
          <TextField {..._attr.COMMENT} />
          <Box {..._attr.CONTROL_BOX}>
            <Button {..._attr.BUTTON_OK    } />
            <Button {..._attr.BUTTON_CANCEL} />
          </Box>
        </Box>
      </Modal>
    );
  }

  //#endregion

  return display();
}